<template>
    <div id="sig-container" class="block full form-horizontal">
        <form @submit.prevent="editarContacto">
            <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
            <div class="widget">
                <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                    <span class="float-right text-muted">
                        <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
                    </span>
                    Gestión
                </div>
                <div class="widget-content border-bottom themed-background-muted text-center">
                    <div class="container">
                        <div class="row mt-2">
                            <label for="valor" class="col-3 control-label text-right"><strong>Valor</strong></label>
                            <div class="col-9">
                                <input type="text" v-model="contacto.valor" id="valor" class="form-control" placeholder="Valor">
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-6 offset-md-3 text-center mt-3">
                                <button class="btn btn-sm btn-info">{{ contacto.id?'Editar':'Guardar' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'EditarContactos',
    data: () => {
        return {
            contacto: {},
            errors: null
        }
    },
    computed: {
        ...mapGetters({'loading': 'loading'}),
    },
    methods: {
        editarContacto() {
            this.$store.dispatch('edit', {endpoint: 'contacto/'+this.contacto.id, params: this.contacto})
            .then(response => {
                this.$notify({
                    title: 'Contacto',
                    type: 'success',
                    content: 'La acción se completó con éxito',
                })
            })
            .catch(error => {
                this.errors = error.data.errors;
                this.$notify({
                    title: 'Contacto',
                    type: 'warning',
                    content: 'Los datos dados no son válidos',
                })
            })
        }
    },
    mounted() {
        this.contacto = this.$store.getters['contacto/contactos'].find(item => item.id == this.$router.currentRoute.params.contacto_id) || {}
    }
}
</script>